export default __webpack_public_path__ + "static/media/erc_eu_logo.60477c53.png";